import React, { useEffect, useState } from 'react';
import { useClientPortal } from '../../../context/ClientPortalContext';
import { PortalProfileService } from '../../../services/portal/portalProfileService';

const ProfileEducation = () => {
    const { clientId } = useClientPortal();
    const [education, setEducation] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (clientId) {
            loadEducation();
        }
    }, [clientId]);

    const loadEducation = async () => {
        setLoading(true);
        const { data } = await PortalProfileService.listEducation(clientId);
        setEducation(data || []);
        setLoading(false);
    };

    if (loading) return <div className="p-6 text-center text-slate-500">Loading education details...</div>;

    return (
        <div className="space-y-6">
            <section className="bg-white border border-slate-200 rounded-2xl p-6">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-semibold text-slate-900">Education</h3>
                    {/* Add button can be implemented here */}
                </div>

                {education.length === 0 ? (
                    <p className="text-sm text-slate-500">No education records found.</p>
                ) : (
                    <div className="space-y-4">
                        {education.map((edu, index) => (
                            <div key={index} className="p-4 border border-slate-100 rounded-lg bg-slate-50">
                                <h4 className="font-medium text-slate-900">{edu.institution}</h4>
                                <p className="text-sm text-slate-600">{edu.qualification} - {edu.field_of_study}</p>
                                <p className="text-xs text-slate-500 mt-1">
                                    {edu.start_date} - {edu.end_date || 'Present'}
                                </p>
                            </div>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
};

export default ProfileEducation;
